import React, { useState } from 'react'
import { ConsequenceAndProbabilityRisk, RiskAnalysis, RiskAnalysisStatus } from '../../../../api/schemas/schema'
import { t } from 'i18next'
import { CardHeader } from '../../../common/header/CardHeader'
import { List } from '../../../common/list/List'
import { getRiskAnalysisColumns } from '../../../../helpers/riskAnalysisHelper'
import { ConsequenceRiskAnalysePhoneItem } from './ConsequenceRiskAnalysePhoneItem'
import { ModalAnalyseRisk } from './modals/ModalConsequenceRiskAnalyse'
import { IItemState } from '../../../../interfaces/IItemState'
import { InfoMessageBar } from '../../../common/other/InfoMessageBar'

type ConsequenceRiskAnalyseProps = {
   setRiskAnalysisState: React.Dispatch<React.SetStateAction<IItemState<RiskAnalysis>>>
   analysisState: IItemState<RiskAnalysis>
}
export const ConsequenceRiskAnalyse = ({ setRiskAnalysisState, analysisState }: ConsequenceRiskAnalyseProps) => {
   const [selectedRisk, setSelectedRisk] = useState<ConsequenceAndProbabilityRisk>(null)
   const analysis = analysisState.item

   return (
      <>
         <CardHeader title={t('RiskAnalysis')} />
         {analysis.consequenceAndProbabilityRisks.length === 0 ? (
            <InfoMessageBar title={t('NoRisksIdentifiedYet')} />
         ) : (
            <>
               <List
                  columns={getRiskAnalysisColumns()}
                  columnSizingOptions={{
                     riskScenario: { autoFitColumns: true, minWidth: 150, idealWidth: 600 },
                     consequence: { autoFitColumns: true, minWidth: 250, idealWidth: 600 },
                     consequenceScaleLifeHealth: { autoFitColumns: true, minWidth: 35, idealWidth: 70 },
                     consequenceScaleEconomy: { autoFitColumns: true, minWidth: 35, idealWidth: 70 },
                     consequenceScaleEnvironment: { autoFitColumns: true, minWidth: 35, idealWidth: 70 },
                     consequenceScaleBrand: { autoFitColumns: true, minWidth: 50, idealWidth: 80 },
                     probability: { autoFitColumns: true, minWidth: 50, idealWidth: 80 },
                  }}
                  resizableColumns
                  items={analysis.consequenceAndProbabilityRisks}
                  onRowClick={(item) => setSelectedRisk(item)}
                  renderPhoneBodyItem={(item, i) => <ConsequenceRiskAnalysePhoneItem item={item} />}
               />
               <ModalAnalyseRisk
                  setRiskAnalysisState={setRiskAnalysisState}
                  analysisState={analysisState}
                  selectedRisk={selectedRisk}
                  close={() => setSelectedRisk(null)}
                  isDetermined={(selectedRisk && selectedRisk.determined) || analysis.status !== RiskAnalysisStatus.Ongoing}
               />
            </>
         )}
      </>
   )
}
